// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3wyyK","colMin":"styles_colMin__2Ya_c"};